import React from 'react'
import { Icon } from './Home.elements'

type Props = {
  className?: string
}

export const SettingsIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 24 24"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path stroke="currentColor" strokeWidth="2" d="M2 7h8"/>
    <path stroke="currentColor" strokeWidth="2" d="M19 7h3"/>
    <circle cx="13" cy="7" r="3" stroke="#7F8385" strokeWidth="2"/>
    <path stroke="currentColor" strokeWidth="2" d="M22 17h-8"/>
    <path stroke="currentColor" strokeWidth="2" d="M5 17H2"/>
    <circle r="3" transform="matrix(-1 0 0 1 8 17)" stroke="#7F8385" strokeWidth="2"/>
  </Icon>
)
